export default "__VITE_ASSET__CCocaRfd__"